package techla.base

actual fun uniqueIndexValue() : String {
    return uuidv4()
}

actual fun uniqueIdentifierValue() : String {
    return uuidv4()
}
